export class AppOAuth2CredentialsUpdateRequest
{
    constructor(
            public readonly appName:string, 
            public readonly authProvider:string, 
            public readonly clientId:string, 
            public readonly clientSecret:string, 
            public readonly scope:string, 
            public readonly customDomain:string, 
            public readonly apiKey:string
        )
    {}
}
